export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path class=\"path\" d=\"M24 8.764l-8.628-.75L12 0 8.628 8.026 0 8.764l6.552 5.726L4.584 23 12 18.485 19.416 23l-1.956-8.51L24 8.764zm-12.006 7.48l-4.635 2.744 1.233-5.175L4.5 10.332l5.399-.46L11.994 5 14.1 9.884l5.399.46-4.092 3.482L16.641 19l-4.647-2.756z\" fill=\"#000\" fill-rule=\"nonzero\"/><path d=\"M0 0h24v24H0z\"/></g>",
  "attrs": {
    "width": "24",
    "height": "23",
    "viewBox": "0 0 24 23",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};